import script from "./visitor-card.vue?vue&type=script&setup=true&lang=js"
export * from "./visitor-card.vue?vue&type=script&setup=true&lang=js"

import "./visitor-card.vue?vue&type=style&index=0&id=7ec05662&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec05662"]])

export default __exports__